import React from 'react';
import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {makeStyles} from "@material-ui/core/styles";
import logo from '../images/logo.svg';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  flexGrow: {
    flexGrow: 1
  },
  btn1: {
    marginRight: theme.spacing(2),
    backgroundColor: 'white'
  },
  btn2: {
    color: 'white'
  },
}));

export default function Header() {
  const classes = useStyles();
  return (
    <AppBar position="relative" elevation={0}>
      <Toolbar>
        <div className={classes.flexGrow}>
          <img src={logo} alt="Logo" className={classes.icon} width="50" height="50"/>
        </div>
      </Toolbar>
    </AppBar>
  );
}
